import _extends from "@babel/runtime/helpers/extends";
import { styled, Switch } from "@mui/material";
export var IOSSwitch = styled(function (props) { /*#__PURE__*/ return React.createElement(Switch, _extends({
    focusVisibleClassName: ".Mui-focusVisible",
    disableRipple: true
}, props)); })(function (_ref) {
    var theme = _ref.theme;
    return {
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#3697FF',
                    opacity: 1,
                    border: 0
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5
                }
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#3697FF',
                border: '6px solid #fff'
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.grey[100]
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7
            }
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: '#E9E9EA',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500
            })
        }
    };
});
